import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function GoogleSignIn() {
  const navigate = useNavigate();
  const { setUserFromGoogle } = useAuth();

  useEffect(() => {
    const m = (window.location.hash || '').match(/token=([^&]+)/);
    if (!m) {
      toast.error('Google sign-in failed');
      navigate('/login', { replace: true });
      return;
    }
    localStorage.setItem('aawta_token', decodeURIComponent(m[1]));
    api
      .get('/auth/me')
      .then((r) => {
        localStorage.setItem('aawta_user', JSON.stringify(r.data));
        setUserFromGoogle(r.data);
        window.history.replaceState(null, '', window.location.pathname);
        toast.success(`Welcome, ${r.data.full_name}`);
        navigate('/', { replace: true });
      })
      .catch(() => {
        localStorage.removeItem('aawta_token');
        toast.error('Google sign-in failed');
        navigate('/login', { replace: true });
      });
  }, [navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="flex items-center gap-3 text-navy" data-testid="google-signin-loading">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span className="font-medium">Signing you in with Google…</span>
      </div>
    </div>
  );
}
